import { Stack, Text } from '@chakra-ui/react';
import palette from '@theme/assets/palette';
import { FC } from 'react';

interface Props {
    title: string;
}

const SmallSectionTitleComponent: FC<Props> = ({ title }) => {
    return (
        <Stack paddingTop="10px" alignSelf="stretch" direction="row" justify="center" align="center" spacing="10px">
            <Text variant="titleM" color={palette.ui02} flex="1">
                {title}
            </Text>
        </Stack>
    );
};

export default SmallSectionTitleComponent;
